'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const opacity = {
    disabled: '0.5',
    'disabled-subtle': '0.75',
    loading: '0.5',
    muted: '0.75'
};
const preset = {
    content: [],
    theme: {
        extend: {
            opacity
        }
    }
};

exports.default = preset;
exports.opacity = opacity;
//# sourceMappingURL=opacity.js.map
